import React from 'react';
import PropTypes from 'prop-types';

const DownArrow = props => (
    <svg
        {...props}
        width={props.width || '13'}
        height={props.height || '13'}
        viewBox="0 0 1792 1792"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill={`${props.color}` || `#000000`}
            d="M1395 736q0 13-10 23l-466 466q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l393 393 393-393q10-10 23-10t23 10l50 50q10 10 10 23z"
        />
    </svg>
);

DownArrow.propTypes = {
    color: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number
};

export default DownArrow;
